module.exports = __webpack_public_path__ + "img/20231026_191548.6a5b762b.png";